module.exports = new __parcel__URL__("explosiveshot.d0cda28b.png").toString();